// extracted by mini-css-extract-plugin
export default {"textarea_wrapper":"styles_textarea_wrapper__KFd93","label":"styles_label__Vw6Qm","textarea":"styles_textarea__G6h5t","readonly":"styles_readonly__NIxdr"};